import { BillingAddress } from './billing-address';
import { ComposedReferralData } from './composed-referral-data';
import { Role } from './role';
import { Type } from './type';
import { CountryGroup } from './user-country-group';
import { UserExtras } from './user-extras';
import { UtmData } from './utm';

/**
 * @deprecated The loyalty program was shut down
 */
export enum LoyaltyLevel {
  Unregistered = 'unregistered',
  Pending = 'pending',
  Green = 'green',
  Silver = 'silver',
  Gold = 'gold',
  Platinum = 'platinum',
  Banned = 'banned',
}

// допустимые типы параметров
export const allowedRegisterTypes = [Type.Demo, Type.Trader, Type.Partner];

// допустимые типы параметров
export const allowedPersonTypes = [
  Role.Investor,
  Role.Trader,
  Role.Partner,
  Role.TradingPlatform,
  Role.Exchanger,
];

export const rolesForHeader = {
  [Role.Exchanger]: Role.Partner,
};

export enum ConfirmationMethod {
  Sms = 'sms',
  Email = 'email',
}

export class User {
  id = 0;
  name = '';
  email = '';
  authKey = '';
  country = ''; // ISO 3166-1 alpha-3
  language = ''; // ISO 639-1
  timezone = '';
  phoneCode: number;
  phoneNumber = '';
  passport = '';
  isEmailConfirmed = false;
  isPhoneConfirmed = false;
  isCountryConfirmed = false;
  isEnabled = false;
  isFasapayDisabled = false;
  isVerified = false;
  clientId: string;
  partnerId = 0;
  isVip = false;
  deposit = 0;
  birthDate = '';
  createdAt = '';
  refererBlackList = false;
  confirmationMethod: ConfirmationMethod;
  billingAddress: BillingAddress;
  extras: UserExtras;
  utmData: UtmData;
  countryGroup: CountryGroup;
  loyaltyLevel: LoyaltyLevel = LoyaltyLevel.Unregistered;
  isHasTrades: boolean;
  isUnsubscribed: boolean;
  isTest: boolean;
  updatedAt: string;
  domain: string;
  referralLinkParams?: ComposedReferralData;
}
